function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 19.842a.699.699 0 00.491-.197l6.953-6.58c.1-.098 2.556-2.302 2.556-4.933C20 4.919 18.002 3 14.665 3 12.712 3 10.882 4.513 10 5.368 9.118 4.513 7.288 3 5.335 3 1.998 3 0 4.919 0 8.132c0 2.631 2.455 4.835 2.545 4.912l6.964 6.6a.699.699 0 00.491.198z",
  fillRule: "evenodd"
});
function SvgSaveActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgSaveActive;